import { render, staticRenderFns } from "./CImgRatio.vue?vue&type=template&id=5d2cd020&"
import script from "./CImgRatio.vue?vue&type=script&lang=ts&"
export * from "./CImgRatio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports